import React, { useState } from 'react';
import Col from '@visa/vds/col';
import Search from '@visa/vds/search';
import Input from '@visa/vds/input';
import InputOption from '@visa/vds/input-option';
import Td from '@visa/vds/td';
import Tr from '@visa/vds/tr';
import Icon from '@visa/vds/icon';
import MCSPagedTable from '../../../../components/MCSPagedTable';

const UnselectedUserTable = (props) => {
    const { fetchData, tableState, handleClickAction } = props;
    const [typingTimeOut, setTypingTimeout] = useState({ name: "", timeout: 0 });

    let colHeaders = [
        { displayName: "User ID", name: "volUserId", orderable: true },
        { displayName: "Name", name: "firstName", orderable: true },
        { displayName: "Organization", name: "organizationName", orderable: true },
        { displayName: "BID", name: "bid", orderable: true },
        { displayName: "Region", name: "regionName", orderable: false },
        { displayName: "", name: "action", orderable: false },
    ];

    function fetch(filter) {
        fetchData(filter);
    }

    function handleSearchChange(searchValue) {
        fetch({ ...tableState.filter, selectedPage: 1, search: searchValue });
    }

    const onUnselectedUserManualSearch = (event) => {
        if (event.key === "Enter") {
            handleSearchChange(event.target.value);
            clearTimeout(typingTimeOut.timeout);
        }
    };

    const onUnselectedUserAutoSearch = (searchValue) => {
        if (typingTimeOut.timeout) {
            clearTimeout(typingTimeOut.timeout);
        }
        setTypingTimeout({
            name: searchValue,
            timeout: setTimeout(function () {
                handleSearchChange(searchValue);
            }, 1500),
        });
    };

    return (
        <>
            <Col xl={4} lg={8} md={12} alignEnd>
                <Search aria-label="Demo Example 2" navbar>
                    <Input
                        contentBeforeInput={
                            <InputOption>
                                <Icon name="search" resolution="low" />
                            </InputOption>
                        }
                        aria-label="Site-wide"
                        name="q"
                        placeholder="Search UserID/Name/Organization/BID"
                        type="search"
                        onKeyPress={onUnselectedUserManualSearch}
                        onChange={(e) => onUnselectedUserAutoSearch(e.target.value)}
                        useNativePlaceholder
                    >
                    </Input>
                </Search>
            </Col>
            {tableState.tableData && (
                <MCSPagedTable
                    size={"compact"}
                    colHeaders={colHeaders}
                    usePagination={true}
                    selectedPage={tableState.filter.selectedPage}
                    setSelectedPage={(newPage) => fetch({ ...tableState.filter, selectedPage: newPage })}
                    ordered={tableState.filter.sortBy}
                    setOrdered={(sortBy) => { }}
                    sortData={(sortBy, desc) => fetch({ ...tableState.filter, sortBy: sortBy, isDesc: desc })}
                    isDsc={tableState.filter.isDesc}
                    setDsc={(desc) => { }}
                    totalPages={tableState.totalPage}
                    pageSize={tableState.pageSize}
                    totalCount={tableState.totalCount}
                    tableData={
                        tableState.tableData.map((row, key) => (
                            <Tr key={key}>
                                <Td>{row.volUserId}</Td>
                                <Td>{row.fullName}</Td>
                                <Td>{row.organizationName}</Td>
                                <Td>{row.bid}</Td>
                                <Td>{row.regionName != "" ? row.regionName : "-"}</Td>
                                {<Td><Icon className="vss-clickable-icon" name="account-add" resolution="low" onClick={() => handleClickAction(row)} /></Td>}
                            </Tr>
                        ))
                    }
                />
            )}
        </>
    )
}

export default UnselectedUserTable;